// =============================================================================
// features/sales/campaigns/wizard/NewCampaignWizardPage.tsx — Rota
// `/campanhas/nova` (F35-S08, doc 26 §6.6). Gate próprio de permissão + flag,
// mesmo padrão de CampaignsPage.tsx (fora de files_allowed — não importado,
// só o mesmo tratamento): acesso direto sem permissão/flag mostra um estado
// PRÓPRIO, nunca uma tela quebrada.
//
// Criar/ativar campanha exige `sales_campaigns:manage` (doc 26 §12) — mais
// restritivo que a leitura de `/campanhas`.
// =============================================================================

import * as React from 'react';

import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { useAuth } from '../../../../lib/auth-store';

import { WizardContent } from './WizardContent';

const FLAG_KEY = 'sales.campaigns.enabled';
const MANAGE_PERMISSION = 'sales_campaigns:manage';

export function NewCampaignWizardPage(): React.JSX.Element {
  const { hasPermission } = useAuth();
  const { enabled: flagEnabled, isLoading: flagLoading } = useFeatureFlag(FLAG_KEY);

  const canManage = hasPermission(MANAGE_PERMISSION);

  if (!canManage) {
    return (
      <div className="flex flex-col items-center justify-center py-16 gap-3 text-center">
        <p className="font-sans text-sm text-ink-3 max-w-xs">
          Você não tem permissão para criar campanhas comerciais. Fale com um administrador se
          precisar de acesso.
        </p>
      </div>
    );
  }

  if (flagLoading) {
    return (
      <div className="flex flex-col gap-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="h-16 rounded-md animate-pulse"
            style={{ background: 'var(--surface-muted)' }}
            aria-hidden="true"
          />
        ))}
      </div>
    );
  }

  if (!flagEnabled) {
    return (
      <div
        className="flex items-start gap-3 px-4 py-3 rounded-sm border"
        style={{
          background: 'var(--warning-bg)',
          borderColor: 'var(--warning)',
          borderLeftWidth: 3,
        }}
        role="alert"
      >
        <div>
          <p className="font-sans text-sm font-semibold text-ink">Módulo desabilitado</p>
          <p className="font-sans text-xs text-ink-3 mt-0.5">
            A flag <code className="font-mono">{FLAG_KEY}</code> está desativada para esta
            organização.
          </p>
        </div>
      </div>
    );
  }

  return <WizardContent />;
}
